import React from 'react';
const Undergraduate = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Undergraduate Programs</h1>
          <div className="w-24 h-1 bg-primary mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto">
            Discover our comprehensive range of undergraduate programs designed to provide a strong foundation for your future career.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Program Card 1 */}
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">Bachelor of Science in Computer Science</h2>
            <p className="text-gray-600 mb-4">
              A 4-year program focusing on software development, algorithms, and computer systems.
            </p>
            <ul className="space-y-2 mb-4">
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Duration: 4 years</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Credits: 120</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Format: Full-time/Part-time</span>
              </li>
            </ul>
            <button className="bg-primary text-white px-6 py-2 rounded-md hover:bg-yellow-600 transition-colors">
              Learn More
            </button>
          </div>

          {/* Program Card 2 */}
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
            <h2 className="text-2xl font-semibold text-gray-800 mb-3">Bachelor of Business Administration</h2>
            <p className="text-gray-600 mb-4">
              Develop essential business skills with our comprehensive BBA program.
            </p>
            <ul className="space-y-2 mb-4">
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Duration: 3-4 years</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Specializations Available</span>
              </li>
              <li className="flex items-center">
                <span className="text-primary mr-2">✓</span>
                <span>Internship Opportunities</span>
              </li>
            </ul>
            <button className="bg-primary text-white px-6 py-2 rounded-md hover:bg-yellow-600 transition-colors">
              Learn More
            </button>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default Undergraduate;
